import { useState, useRef } from 'react';
import NumericTimeAgoWithUnit from "core/components/TimeAgo/NumericTimeAgoWithUnit";
import type { Comment } from '.';
import CLikeComunity from 'core/components/CLikeCommunity';
import Image from "core/components/Image";
import { nl2br } from 'core/utils/helper';
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import useOnClickOutside from "core/hooks/useOnClickOutside";
import { route, RouterName } from "core/router";
import CommentItemDelete from './Delete'
import CommentItemReport from './Report'

const CommentItem = ({ comment, reload }: { comment: Comment, reload: any}) => {
  const { user } = comment;
  const avatar = user?.avatar?.url?.thumbnail || '';
  const name = user?.name || `@${user?.username}` || '';
  const navigate = useCustomNavigate();
  const [showAction, setShowAction] = useState<boolean>(false);
  const groupRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(groupRef, () => {
    setShowAction(false);
  });

  const handleClick = () => {
    if (user?.id) {
      navigate(route(RouterName.PERSONAL_CHANNEL, user?.id));
    }
  };

  return (
    <div
      className={`flex gap-3 w-full group px-4 ${showAction ? 'bg-primary/10' : ''}`}
      ref={groupRef}
    >
      <div className="h-full py-1" onClick={handleClick}>
        <Image
          src={avatar}
          className="rounded-full float-left w-8 min-w-8 h-8 object-cover"
          alt={user?.name}
        />
      </div>
      <div className="w-full space-y-1.5 pb-2.5 border-b group-last:border-b-0 py-1">
        <div
          className="space-y-1.5"
          onClick={() => setShowAction(!showAction)}
        >
          <div
            className="text-[13px] text-[#111111] font-medium w-fit"
            onClick={handleClick}
          >
            {name}
          </div>
          <div
            className="text-[13px] text-[#333333]"
            dangerouslySetInnerHTML={{__html: nl2br(comment.content || '')}}
          />
          <div className="flex justify-between items-center">
            <div className="text-[11px] text-[#777777]">
              <NumericTimeAgoWithUnit
                createdAt={comment.created_at}
                locale={(window as any)._APP_LANG}
              />
            </div>
            <div>
              <CLikeComunity
                id={comment.post_id}
                idComment={comment.id}
                type="comment"
                countLike={comment.total_reactions}
                active={comment.user_reaction}
                reload={reload}
              />
            </div>
          </div>
        </div>
        <CommentItemDelete comment={comment} isShow={(showAction && comment)} />
        <CommentItemReport comment={comment} isShow={(showAction && comment)} />
      </div>
    </div>
  );
}

export default CommentItem;
